function AvailableSoon() {
    return <section className="m-4 md:w-2/3 md:mx-auto md:my-16">
    <p className="m-4 p-4 md:w-2/3 md:my-8 md:mx-auto border rounded">
        Cette fonctionnalité est en cours de développement, elle sera bientôt disponible. 😉
    </p>
    </section>
}

export default AvailableSoon